function preventClose(state, changes) {
  if (changes.type === 'closing' && state.openIndexes.length < 2) {
    return null
  }
  return changes
}

function single(state, changes) {
  if (changes.type === 'opening') {
    return {
      openIndexes:
        changes.openIndexes.length > 0
          ? changes.openIndexes.slice(-1)
          : changes.openIndexes,
    }
  }
  return changes
}

function combineReducers(...reducers) {
  return (state, changes) => {
    for (let reducer of reducers) {
      const result = reducer(state, changes)
      if (result !== changes) {
        return result
      }
    }
    return changes
  }
}

export { combineReducers, preventClose, single }



// WEBPACK FOOTER //
// ./src/components/Accordion/shared.js